<script>
import FeaturePlaceholder from './FeaturePlaceholder.vue';
import TolaSignal from 'dashboard/components-next/empty-state/TolaSignal.vue';

export default {
  components: { FeaturePlaceholder, TolaSignal },
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <div
    class="flex flex-col items-center justify-center h-full max-w-md px-6 text-center"
  >
    <TolaSignal icon="i-lucide-messages-square" />
    <h2 class="mt-1 text-xl font-semibold tracking-tight text-n-slate-12">
      {{ message }}
    </h2>
    <!-- Cmd bar, keyboard shortcuts placeholder -->
    <FeaturePlaceholder />
  </div>
</template>
